import * as React from 'react';

type Props = {
  className?: string;
};

const SvgIcon = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
    className={props.className}
  >
    <path
      fill="currentColor"
      d="M9.05 9.68c1.62.003 2.933-.876 2.935-1.962.001-1.086-1.31-1.968-2.928-1.97-1.62-.003-2.933.875-2.935 1.961-.001 1.086 1.31 1.969 2.929 1.971"
    ></path>
    <path
      fill="currentColor"
      d="M9.05 10.324c1.09.001 1.976-.59 1.977-1.323.002-.732-.882-1.327-1.973-1.328s-1.977.59-1.978 1.322.883 1.327 1.974 1.329"
    ></path>
    <path
      fill="currentColor"
      d="m9.733 9.988.442.417-.389.545.055-.518-.505-.171zM8.366 9.986l-.444.415.388.546-.054-.518.505-.17zM9.862 7.505l-.294-.31 3.245-3.08L8.776.755l4.697 3.323z"
    ></path>
    <path
      fill="currentColor"
      d="m10.848 7.77-.155-.4 4.71-1.827-2.995-5.02 3.64 5.229zM16.922 12.852 14.728 9.63l-3.57-1.25.141-.403 3.718 1.301zM10.747 16.64l2.128-3.834-1.97-3.874.381-.194 2.078 4.088zM7.67 7.501l.296-.308L4.73 4.102 8.777.754 4.07 4.064z"
    ></path>
    <path
      fill="currentColor"
      d="m6.972 7.764.156-.399-4.704-1.842L5.435.512 1.778 5.73zM.882 12.827l2.204-3.214 3.574-1.24-.14-.403-3.722 1.29zM7.044 16.634l-2.115-3.84L6.91 8.924l-.38-.194-2.092 4.081z"
    ></path>
  </svg>
);

export default SvgIcon;
